import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { LandingPageDetails } from '../../interfaces/details';
import { DSTheme } from '../../styles/themes/types';

const useStyles = makeStyles((theme: DSTheme) => ({
  landingCard: {
    backgroundColor: theme.palette.background.elevation1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '244px',
    height: '344px',
    minHeight: '320px',
    padding: '40px',

    [theme.breakpoints.up('md')]: {
      width: '365px',
    },

    boxShadow: '0px 5px 26px rgba(0, 0, 0, 0.06)',
    borderRadius: '16px',

    '& ul': {
      paddingLeft: '20px',
    },
  },
  text: {
    color: theme.palette.type === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
  },
}));

const LandingCard: React.FC<LandingPageDetails> = ({ Icon, title, details, link }) => {
  const theme = useTheme<DSTheme>();
  const classes = useStyles();
  const fill =
    theme.palette.type === 'dark'
      ? theme.palette.primary.main
      : theme.palette.background.elevation1;
  const stroke =
    theme.palette.type === 'dark' ? theme.palette.primary.contrastText : theme.palette.primary.main;

  return (
    <div className={classes.landingCard}>
      <div>
        <Icon fill={fill} stroke={stroke} />
      </div>

      <Typography className={classes.text} variant="subtitle1">
        <b>{title}</b>
      </Typography>

      <ul>
        {details.map((detail) => (
          <li key={detail}>
            <Typography color="textPrimary">{detail}</Typography>
          </li>
        ))}
      </ul>
      <div className="link-row">
        <i className="chevron" />
        <a href={link} target="_blank" rel="noopener noreferrer">
          <Typography className={classes.text}>
            <b>Read More</b>
          </Typography>
        </a>
      </div>
    </div>
  );
};

export default LandingCard;
